(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["entrada-optimizada"] && !Shopify.designMode) return;
  try {
    
(function(){
  function montar(root){
    if(root.dataset.montada) return;
    root.dataset.montada='1';
    var grupoUno=root.querySelector('[data-grupo-uno]');
    var bienvenida=root.querySelector('.enop-bienvenida');
    var grupoDos=null,interiorCargado=false,productosCargados=false,listo=false,dentro=false,visible=false,frame=0,activo=true;
    var media=window.matchMedia('(prefers-reduced-motion: reduce)');
    var tareas=[];
    function esperarImagenes(nodo){
      return Promise.all(Array.from(nodo.querySelectorAll('img')).map(function(img){
        if(img.complete) return Promise.resolve();
        return new Promise(function(resolve){
          var terminado=false;
          function fin(){if(terminado)return;terminado=true;clearTimeout(reloj);img.removeEventListener('load',fin);img.removeEventListener('error',fin);resolve();}
          var reloj=setTimeout(fin,8000);img.addEventListener('load',fin,{once:true});img.addEventListener('error',fin,{once:true});
        });
      }));
    }
    function preparar(){
      if(!interiorCargado){
        interiorCargado=true;
        var fondo=root.querySelector('[data-interior-template]');
        if(fondo){var padre=fondo.parentNode;padre.appendChild(fondo.content.cloneNode(true));fondo.remove();tareas.push(esperarImagenes(padre));}
      }
      if(!productosCargados){
        productosCargados=true;
        var plantilla=root.querySelector('[data-productos-template]');
        if(plantilla){
          var contenedor=document.createElement('div');contenedor.hidden=true;
          contenedor.appendChild(plantilla.content.cloneNode(true));plantilla.replaceWith(contenedor);
          grupoDos=contenedor.querySelector('[data-grupo-dos]');
          if(grupoDos){grupoDos.inert=true;grupoDos.setAttribute('aria-hidden','true');}
          tareas.push(esperarImagenes(contenedor));
          Promise.all(tareas).then(function(){
            if(!activo)return;
            if(grupoDos){contenedor.replaceWith(grupoDos);grupoDos.hidden=true;}
            listo=true;if(media.matches)reducido();else solicitar();
          });
        }else{Promise.all(tareas).then(function(){if(!activo)return;listo=true;solicitar();});}
      }
    }
    function cambiar(nuevo){
      if(dentro===nuevo)return;dentro=nuevo;
      root.classList.toggle('enop-dentro',nuevo);
      if(grupoUno){grupoUno.inert=nuevo;grupoUno.setAttribute('aria-hidden',String(nuevo));}
      if(bienvenida){bienvenida.inert=nuevo;bienvenida.setAttribute('aria-hidden',String(nuevo));}
      if(grupoDos){grupoDos.hidden=!nuevo;grupoDos.inert=!nuevo;grupoDos.setAttribute('aria-hidden',String(!nuevo));}
    }
    function actualizar(){
      frame=0;if(!activo||!visible||media.matches||document.hidden)return;
      var rect=root.getBoundingClientRect();
      var alto=root.querySelector('.enop-stage').getBoundingClientRect().height;
      var total=Math.max(1,rect.height-alto);
      var progreso=Math.max(0,Math.min(1,-rect.top/total));
      if(progreso>=.08)preparar();
      var fundido=listo?Math.max(0,Math.min(1,(progreso-.20)/.38)):0;
      root.style.setProperty('--enop-fundido-interior',fundido);
      cambiar(progreso>=.58&&listo);
    }
    function solicitar(){if(!frame&&visible&&!media.matches&&!document.hidden)frame=requestAnimationFrame(actualizar);}
    function reducido(){
      if(!activo)return;
      root.classList.toggle('enop-reducido',media.matches);
      if(media.matches){preparar();cambiar(false);if(grupoDos){grupoDos.hidden=false;grupoDos.inert=false;grupoDos.removeAttribute('aria-hidden');}}
      else{if(grupoDos){grupoDos.hidden=true;grupoDos.inert=true;grupoDos.setAttribute('aria-hidden','true');}solicitar();}
    }
    var observador=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;if(visible)solicitar();else if(frame){cancelAnimationFrame(frame);frame=0;}},{rootMargin:'0px'});
    observador.observe(root);
    window.addEventListener('scroll',solicitar,{passive:true});window.addEventListener('resize',solicitar,{passive:true});
    document.addEventListener('visibilitychange',solicitar);media.addEventListener('change',reducido);reducido();
    root.enopLimpiar=function(){activo=false;observador.disconnect();cancelAnimationFrame(frame);window.removeEventListener('scroll',solicitar);window.removeEventListener('resize',solicitar);document.removeEventListener('visibilitychange',solicitar);media.removeEventListener('change',reducido);};
  }
  function iniciar(contexto){if(contexto.matches&&contexto.matches('[data-entrada-optimizada]'))montar(contexto);contexto.querySelectorAll('[data-entrada-optimizada]').forEach(montar);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){iniciar(document);},{once:true});else iniciar(document);
  document.addEventListener('shopify:section:load',function(e){iniciar(e.target);});
  document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('[data-entrada-optimizada]').forEach(function(root){if(root.enopLimpiar)root.enopLimpiar();});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["entrada-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.lql-track').forEach(function(track){
    var stage = track.querySelector('.lql-stage');
    if(!stage) return;
    var ticking = false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }
    function update(){
      var rect = track.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
      if(reduce){ p = 1; }
      var doorP = clamp(p/0.4, 0, 1);
      var interiorP = clamp((p-0.28)/0.42, 0, 1);
      var prodP = clamp((p-0.55)/0.45, 0, 1);
      var ronda2P = clamp((prodP - 0.45) / 0.55, 0, 1);
      stage.style.setProperty('--p', p);
      stage.style.setProperty('--door-p', doorP);
      stage.style.setProperty('--interior-p', interiorP);
      stage.style.setProperty('--prod-p', prodP);
      stage.style.setProperty('--ronda2-p', ronda2P);
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
